module.exports = __webpack_public_path__ + "static/media/manager.f371620a.svg";